import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ensureAccessTokenFresh } from '../services/api';

/**
 * Keeps the access token fresh while the user stays on the app, including
 * after long idle periods or returning to a backgrounded tab.
 */
const SessionKeepAlive = () => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      return undefined;
    }

    const refreshIfNeeded = () => {
      if (document.visibilityState !== 'visible') {
        return;
      }
      ensureAccessTokenFresh().catch(() => {
        // Failed refresh is handled by api interceptors on the next request.
      });
    };

    refreshIfNeeded();

    const intervalId = window.setInterval(refreshIfNeeded, 60 * 1000);
    document.addEventListener('visibilitychange', refreshIfNeeded);
    window.addEventListener('focus', refreshIfNeeded);

    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener('visibilitychange', refreshIfNeeded);
      window.removeEventListener('focus', refreshIfNeeded);
    };
  }, [isAuthenticated]);

  return null;
};

export default SessionKeepAlive;
